import { render, staticRenderFns } from "./VideoProfile.vue?vue&type=template&id=c1406186&scoped=true&"
import script from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoProfile.vue?vue&type=style&index=0&id=c1406186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1406186",
  null
  
)

export default component.exports